// Wave generator for Dragon Keep. Pure and seeded so it can be tested headlessly.

import type { Rng } from '@kit/rng';

export type KnightKind = 'foot' | 'shield' | 'ladder' | 'horse' | 'catapult';

export interface Spawn { kind: KnightKind; lane: 0 | 1 | 2; delay: number }   // delay = seconds after wave start
export interface Wave { n: number; speedMul: number; spawns: Spawn[]; catapult: boolean }

export const WAVES = 8;
export const MAX_PER_WAVE = 14;

/** base knights per wave (not counting the catapult) */
export function countFor(n: number): number {
  return Math.min(MAX_PER_WAVE, 4 + Math.floor((n - 1) * 1.3));
}

export function speedFor(n: number): number {
  return Math.round((1 + (n - 1) * 0.08) * 100) / 100;
}

export const KIND_SPEED: Record<KnightKind, number> = { foot: 1, shield: 0.85, ladder: 1.1, horse: 1.6, catapult: 0.7 };
export const KIND_HP: Record<KnightKind, number> = { foot: 1, shield: 2, ladder: 1, horse: 1, catapult: 2 };

export function makeWaves(rng: Rng): Wave[] {
  const out: Wave[] = [];
  for (let n = 1; n <= WAVES; n++) {
    const count = countFor(n);
    const spawns: Spawn[] = [];
    let t = 0.6;
    for (let i = 0; i < count; i++) {
      let kind: KnightKind = 'foot';
      const r = rng();
      if (n >= 3 && r < 0.3) kind = 'shield';
      else if (n >= 2 && r < 0.45) kind = 'ladder';
      else if (n >= 4 && r < 0.62) kind = 'horse';
      spawns.push({ kind, lane: Math.floor(rng() * 3) as 0 | 1 | 2, delay: Math.round(t * 10) / 10 });
      t += Math.max(0.55, 1.3 - n * 0.07) + rng() * 0.4;
    }
    const catapult = n >= 6;
    if (catapult) spawns.push({ kind: 'catapult', lane: Math.floor(rng() * 3) as 0 | 1 | 2, delay: 0.2 });
    out.push({ n, speedMul: speedFor(n), spawns, catapult });
  }
  return out;
}
